import axios, { AxiosRequestConfig, Method } from "axios";
import { environmentConfig } from "config";

type RequestParams = Record<string, any> | unknown;
type RequestHeaders = Record<string, string>;

class NetworkManager {
  private static instance: NetworkManager;
  private authToken: string | null = null;

  static getInstance(): NetworkManager {
    if (!NetworkManager.instance) {
      NetworkManager.instance = new NetworkManager();
    }

    return NetworkManager.instance;
  }

  setAuthorizationToken(token: string) {
    this.authToken = token;
  }

  clearAuthorizationToken() {
    this.authToken = null;
  }

  async requestHandler(
    method: Method,
    path: string,
    params?: RequestParams,
    customHeaders?: RequestHeaders
  ) {
    const headers: RequestHeaders = {
      ...(this.authToken ? { Authorization: this.authToken } : {}),
      ...({
        "Content-Type": "application/x-www-form-urlencoded",
      } as RequestHeaders),
      ...(customHeaders || {}),
    };

    const config: AxiosRequestConfig = {
      method: method,
      url: `${environmentConfig.BASE_URL}${path}`,
      headers,
    };

    if (method === "GET" || method === "DELETE") {
      config.params = params;
    } else {
      config.data = params;
    }

    try {
      const response = await axios(config);
      return response.data;
    } catch (error: any) {
      console.error("API error:", error.response?.data || error.message);
      throw error;
    }
  }

  async get<T>(
    path: string,
    params?: Record<string, unknown>,
    headers?: RequestHeaders
  ): Promise<T> {
    return this.requestHandler("get", path, params, headers);
  }

  async post<T>(
    path: string,
    params?: Record<string, unknown> | unknown,
    headers?: RequestHeaders
  ): Promise<T> {
    return this.requestHandler("post", path, params, headers);
  }

  async put<T>(
    path: string,
    params?: Record<string, unknown>,
    headers?: RequestHeaders
  ): Promise<T> {
    return this.requestHandler("put", path, params, headers);
  }

  async delete<T>(
    path: string,
    params?: Record<string, unknown> | unknown,
    headers?: RequestHeaders
  ): Promise<T> {
    return this.requestHandler("delete", path, params, headers);
  }
}

export default NetworkManager.getInstance();
